module.exports = __webpack_public_path__ + "img/logo.6a336668.png";